export const table = {
  wrapper: {
    style: {
      borderRadius: "8px",
    },
  },

  header: {
    gap: "middle",
    justify: "space-between",
    wrap:'wrap'
  },

  fixedHeader: {
    style: {
      position: 'sticky',
      top: -16,
      zIndex: 1000,
      backgroundColor: "#f5f5f5",
      borderBottom: "1px solid #f0f0f0"
    }
  },

  date: {
    picker: "year",
    allowClear: false,
  },

  addSemesterButton: {
    type: "primary",
  },

  saveButton: {
    type: "primary",
    style: {
      background: "#3368FF",
    },
  },
  calculateButton: {
    type: "primary",
  },
  evaluateButton: {
    type: "primary",
    style: {
      background: "#0eaf65",
    },
  },
};
